function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#365DE6",
  d: "M304,96H112c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h192c8.832,0,16-7.168,16-16C320,103.168,312.832,96,304,96z"
})));
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#365DE6",
  d: "M240,160H112c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16h128c8.832,0,16-7.168,16-16 C256,167.168,248.832,160,240,160z"
})));
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#365DE6",
  d: "M352,0H64C28.704,0,0,28.704,0,64v320c0,6.208,3.584,11.872,9.216,14.496C11.36,399.488,13.696,400,16,400 c3.68,0,7.328-1.28,10.24-3.712L117.792,320H352c35.296,0,64-28.704,64-64V64C416,28.704,387.296,0,352,0z M384,256 c0,17.632-14.336,32-32,32H112c-3.744,0-7.36,1.312-10.24,3.712L32,349.856V64c0-17.632,14.336-32,32-32h288 c17.664,0,32,14.368,32,32V256z"
})));
var _ref5 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#365DE6",
  d: "M448,128c-8.832,0-16,7.168-16,16c0,8.832,7.168,16,16,16c17.664,0,32,14.368,32,32v270.688l-54.016-43.2 c-2.816-2.24-6.368-3.488-9.984-3.488H192c-17.664,0-32-14.368-32-32v-16c0-8.832-7.168-16-16-16c-8.832,0-16,7.168-16,16v16 c0,35.296,28.704,64,64,64h218.368l75.616,60.512C488.896,510.816,492.448,512,496,512c2.336,0,4.704-0.512,6.944-1.568 C508.48,507.744,512,502.144,512,496V192C512,156.704,483.296,128,448,128z"
})));
var _ref6 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref7 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref8 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref9 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref10 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref11 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref12 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref13 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref14 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref15 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref16 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref17 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref18 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref19 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
var _ref20 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", null);
const SvgChat = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChat, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chat.56d04a54.svg";
export { ForwardRef as ReactComponent };